module.exports = __webpack_public_path__ + "static/media/icon-check.978c5f8e.svg";